import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';

import { HomebatteryWizardContainerComponent } from './homebattery-wizard-container/homebattery-wizard.container.component';
import { HomebatteryAdviceFormContainerComponent } from './homebattery-advice-form-container/homebattery-advice-form.container.component';
import { HomebatteryQuestionnaireComponent } from './homebattery-questionnaire/homebattery-questionnaire.component';
import { HomebatteryOrderFormContainerComponent } from './homebattery-order-form-container/homebattery-order-form-container.component';
import { HomebatteryCapacityAdviceContainerComponent } from './homebattery-capacity-advice-container/homebattery-capacity-advice-container.component';

@NgModule({
  imports: [
    provideLazyLoad({
      HomeBatteryWizard: HomebatteryWizardContainerComponent,
      HomebatteryAdviceForm: HomebatteryAdviceFormContainerComponent,
      HomeBatteryQuestionnaire: HomebatteryQuestionnaireComponent,
      HomeBatteryOrderForm: HomebatteryOrderFormContainerComponent,
      HomeBatteryCapacityAdvice: HomebatteryCapacityAdviceContainerComponent,
    }),
  ],
})
export class FehHomebatteryLazyModule {}
